export enum TaskSeverity {
  Unspecified = 0,
  Low = 10,
  Normal = 20,
  High = 30,
  Critical = 40,
}
